module.exports = __webpack_public_path__ + "img/ico_autorizacoes.b7065929.svg";